import type { FileNode } from "@/components/file-tree"

export const reactShadcnProjectStructure: FileNode[] = [
  {
    name: "react-shadcn-template",
    type: "folder",
    children: [
      {
        name: "src",
        type: "folder",
        children: [
          {
            name: "components",
            type: "folder",
            children: [
              {
                name: "ui",
                type: "folder",
                children: [
                  { name: "button.tsx", type: "file", path: "src/components/ui/button.tsx" },
                  { name: "card.tsx", type: "file", path: "src/components/ui/card.tsx" },
                  { name: "input.tsx", type: "file", path: "src/components/ui/input.tsx" },
                  { name: "avatar.tsx", type: "file", path: "src/components/ui/avatar.tsx" },
                ],
              },
              {
                name: "common",
                type: "folder",
                children: [
                  { name: "ErrorBoundary.tsx", type: "file", path: "src/components/common/ErrorBoundary.tsx" },
                  { name: "EmojiPicker.tsx", type: "file", path: "src/components/common/EmojiPicker.tsx" },
                  { name: "Modal.tsx", type: "file", path: "src/components/common/Modal.tsx" },
                  { name: "ConfirmationDialog.tsx", type: "file", path: "src/components/common/ConfirmationDialog.tsx" },
                  { name: "GlobalLoader.tsx", type: "file", path: "src/components/common/GlobalLoader.tsx" },
                ],
              },
              {
                name: "layout",
                type: "folder",
                children: [
                  { name: "Sidebar.tsx", type: "file", path: "src/components/layout/Sidebar.tsx" },
                  { name: "Header.tsx", type: "file", path: "src/components/layout/Header.tsx" },
                ],
              },
              {
                name: "dashboard",
                type: "folder",
                children: [
                  { name: "MetricCard.tsx", type: "file", path: "src/components/dashboard/MetricCard.tsx" },
                  { name: "DataTable.tsx", type: "file", path: "src/components/dashboard/DataTable.tsx" },
                  { name: "ChartCard.tsx", type: "file", path: "src/components/dashboard/ChartCard.tsx" },
                  { name: "ActivityFeed.tsx", type: "file", path: "src/components/dashboard/ActivityFeed.tsx" },
                ],
              },
              {
                name: "chat",
                type: "folder",
                children: [
                  { name: "ChatList.tsx", type: "file", path: "src/components/chat/ChatList.tsx" },
                  { name: "ChatMessage.tsx", type: "file", path: "src/components/chat/ChatMessage.tsx" },
                  { name: "ChatInput.tsx", type: "file", path: "src/components/chat/ChatInput.tsx" },
                ],
              },
            ],
          },
          {
            name: "pages",
            type: "folder",
            children: [
              { name: "DashboardPage.tsx", type: "file", path: "src/pages/DashboardPage.tsx" },
              { name: "ChatPage.tsx", type: "file", path: "src/pages/ChatPage.tsx" },
              { name: "UsersPage.tsx", type: "file", path: "src/pages/UsersPage.tsx" },
              { name: "LoginPage.tsx", type: "file", path: "src/pages/LoginPage.tsx" },
            ],
          },
          {
            name: "views",
            type: "folder",
            children: [
              { name: "DashboardView.tsx", type: "file", path: "src/views/DashboardView.tsx" },
              { name: "ChatView.tsx", type: "file", path: "src/views/ChatView.tsx" },
              { name: "UsersView.tsx", type: "file", path: "src/views/UsersView.tsx" },
            ],
          },
          {
            name: "layouts",
            type: "folder",
            children: [
              { name: "AppLayout.tsx", type: "file", path: "src/layouts/AppLayout.tsx" },
              { name: "AuthLayout.tsx", type: "file", path: "src/layouts/AuthLayout.tsx" },
            ],
          },
          {
            name: "services",
            type: "folder",
            children: [
              {
                name: "api",
                type: "folder",
                children: [
                  { name: "client.ts", type: "file", path: "src/services/api/client.ts" },
                  { name: "auth.service.ts", type: "file", path: "src/services/api/auth.service.ts" },
                  { name: "user.service.ts", type: "file", path: "src/services/api/user.service.ts" },
                  { name: "product.service.ts", type: "file", path: "src/services/api/product.service.ts" },
                ],
              },
            ],
          },
          {
            name: "store",
            type: "folder",
            children: [
              { name: "authStore.ts", type: "file", path: "src/store/authStore.ts" },
              { name: "themeStore.ts", type: "file", path: "src/store/themeStore.ts" },
              { name: "sidebarStore.ts", type: "file", path: "src/store/sidebarStore.ts" },
              { name: "confirmationStore.ts", type: "file", path: "src/store/confirmationStore.ts" },
              { name: "loaderStore.ts", type: "file", path: "src/store/loaderStore.ts" },
            ],
          },
          {
            name: "hooks",
            type: "folder",
            children: [
              { name: "useAuth.ts", type: "file", path: "src/hooks/useAuth.ts" },
              { name: "useTheme.ts", type: "file", path: "src/hooks/useTheme.ts" },
              { name: "useLocalStorage.ts", type: "file", path: "src/hooks/useLocalStorage.ts" },
              { name: "useProducts.ts", type: "file", path: "src/hooks/useProducts.ts" },
            ],
          },
          {
            name: "types",
            type: "folder",
            children: [
              { name: "auth.types.ts", type: "file", path: "src/types/auth.types.ts" },
              { name: "user.types.ts", type: "file", path: "src/types/user.types.ts" },
              { name: "chat.types.ts", type: "file", path: "src/types/chat.types.ts" },
              { name: "product.types.ts", type: "file", path: "src/types/product.types.ts" },
            ],
          },
          {
            name: "constants",
            type: "folder",
            children: [
              { name: "routes.const.ts", type: "file", path: "src/constants/routes.const.ts" },
              { name: "api.const.ts", type: "file", path: "src/constants/api.const.ts" },
            ],
          },
          {
            name: "utils",
            type: "folder",
            children: [
              { name: "format.ts", type: "file", path: "src/utils/format.ts" },
              { name: "validation.ts", type: "file", path: "src/utils/validation.ts" },
            ],
          },
          { name: "App.tsx", type: "file", path: "src/App.tsx" },
          { name: "main.tsx", type: "file", path: "src/main.tsx" },
        ],
      },
      { name: "package.json", type: "file", path: "package.json" },
      { name: "vite.config.ts", type: "file", path: "vite.config.ts" },
      { name: "tsconfig.json", type: "file", path: "tsconfig.json" },
      { name: "tailwind.config.js", type: "file", path: "tailwind.config.js" },
    ],
  },
]

export const nextShadcnProjectStructure: FileNode[] = [
  {
    name: "next-shadcn-template",
    type: "folder",
    children: [
      {
        name: "src",
        type: "folder",
        children: [
          {
            name: "app",
            type: "folder",
            children: [
              { name: "layout.tsx", type: "file", path: "src/app/layout.tsx" },
              { name: "page.tsx", type: "file", path: "src/app/page.tsx" },
              { name: "error.tsx", type: "file", path: "src/app/error.tsx" },
              { name: "not-found.tsx", type: "file", path: "src/app/not-found.tsx" },
              {
                name: "dashboard",
                type: "folder",
                children: [
                  { name: "page.tsx", type: "file", path: "src/app/dashboard/page.tsx" },
                ],
              },
              {
                name: "chat",
                type: "folder",
                children: [
                  { name: "page.tsx", type: "file", path: "src/app/chat/page.tsx" },
                ],
              },
              {
                name: "login",
                type: "folder",
                children: [
                  { name: "page.tsx", type: "file", path: "src/app/login/page.tsx" },
                ],
              },
            ],
          },
          {
            name: "components",
            type: "folder",
            children: [
              {
                name: "ui",
                type: "folder",
                children: [
                  { name: "button.tsx", type: "file", path: "src/components/ui/button.tsx" },
                  { name: "card.tsx", type: "file", path: "src/components/ui/card.tsx" },
                  { name: "input.tsx", type: "file", path: "src/components/ui/input.tsx" },
                ],
              },
              {
                name: "common",
                type: "folder",
                children: [
                  { name: "ErrorBoundary.tsx", type: "file", path: "src/components/common/ErrorBoundary.tsx" },
                  { name: "EmojiPicker.tsx", type: "file", path: "src/components/common/EmojiPicker.tsx" },
                  { name: "Modal.tsx", type: "file", path: "src/components/common/Modal.tsx" },
                ],
              },
              {
                name: "layout",
                type: "folder",
                children: [
                  { name: "Sidebar.tsx", type: "file", path: "src/components/layout/Sidebar.tsx" },
                  { name: "Header.tsx", type: "file", path: "src/components/layout/Header.tsx" },
                  { name: "AppLayout.tsx", type: "file", path: "src/components/layout/AppLayout.tsx" },
                ],
              },
              {
                name: "dashboard",
                type: "folder",
                children: [
                  { name: "MetricCard.tsx", type: "file", path: "src/components/dashboard/MetricCard.tsx" },
                  { name: "DataTable.tsx", type: "file", path: "src/components/dashboard/DataTable.tsx" },
                ],
              },
              {
                name: "views",
                type: "folder",
                children: [
                  { name: "DashboardView.tsx", type: "file", path: "src/components/views/DashboardView.tsx" },
                  { name: "ChatView.tsx", type: "file", path: "src/components/views/ChatView.tsx" },
                ],
              },
            ],
          },
          {
            name: "services",
            type: "folder",
            children: [
              {
                name: "api",
                type: "folder",
                children: [
                  { name: "client.ts", type: "file", path: "src/services/api/client.ts" },
                  { name: "auth.service.ts", type: "file", path: "src/services/api/auth.service.ts" },
                ],
              },
            ],
          },
          {
            name: "store",
            type: "folder",
            children: [
              { name: "authStore.ts", type: "file", path: "src/store/authStore.ts" },
              { name: "themeStore.ts", type: "file", path: "src/store/themeStore.ts" },
              { name: "sidebarStore.ts", type: "file", path: "src/store/sidebarStore.ts" },
            ],
          },
          {
            name: "types",
            type: "folder",
            children: [
              { name: "auth.types.ts", type: "file", path: "src/types/auth.types.ts" },
              { name: "chat.types.ts", type: "file", path: "src/types/chat.types.ts" },
            ],
          },
        ],
      },
      { name: "package.json", type: "file", path: "package.json" },
      { name: "next.config.ts", type: "file", path: "next.config.ts" },
      { name: "tsconfig.json", type: "file", path: "tsconfig.json" },
      { name: "tailwind.config.ts", type: "file", path: "tailwind.config.ts" },
    ],
  },
]

export const mongoDBProjectStructure: FileNode[] = [
  {
    name: "nest-mongodb-template",
    type: "folder",
    children: [
      {
        name: "src",
        type: "folder",
        children: [
          {
            name: "auth",
            type: "folder",
            children: [
              {
                name: "decorators",
                type: "folder",
                children: [
                  { name: "current-user.decorator.ts", type: "file", path: "src/auth/decorators/current-user.decorator.ts" },
                  { name: "public.decorator.ts", type: "file", path: "src/auth/decorators/public.decorator.ts" },
                  { name: "index.ts", type: "file", path: "src/auth/decorators/index.ts" },
                ],
              },
              {
                name: "dto",
                type: "folder",
                children: [
                  { name: "register.dto.ts", type: "file", path: "src/auth/dto/register.dto.ts" },
                  { name: "login.dto.ts", type: "file", path: "src/auth/dto/login.dto.ts" },
                  { name: "refresh-token.dto.ts", type: "file", path: "src/auth/dto/refresh-token.dto.ts" },
                  { name: "auth-response.dto.ts", type: "file", path: "src/auth/dto/auth-response.dto.ts" },
                  { name: "index.ts", type: "file", path: "src/auth/dto/index.ts" },
                ],
              },
              {
                name: "guards",
                type: "folder",
                children: [
                  { name: "jwt-auth.guard.ts", type: "file", path: "src/auth/guards/jwt-auth.guard.ts" },
                  { name: "index.ts", type: "file", path: "src/auth/guards/index.ts" },
                ],
              },
              {
                name: "oauth",
                type: "folder",
                children: [
                  { name: "oauth.controller.ts", type: "file", path: "src/auth/oauth/oauth.controller.ts" },
                  { name: "index.ts", type: "file", path: "src/auth/oauth/index.ts" },
                ],
              },
              {
                name: "schemas",
                type: "folder",
                children: [
                  { name: "refresh-token.schema.ts", type: "file", path: "src/auth/schemas/refresh-token.schema.ts" },
                  { name: "index.ts", type: "file", path: "src/auth/schemas/index.ts" },
                ],
              },
              {
                name: "strategies",
                type: "folder",
                children: [
                  { name: "jwt.strategy.ts", type: "file", path: "src/auth/strategies/jwt.strategy.ts" },
                  { name: "google.strategy.ts", type: "file", path: "src/auth/strategies/google.strategy.ts" },
                  { name: "index.ts", type: "file", path: "src/auth/strategies/index.ts" },
                ],
              },
              { name: "auth.controller.ts", type: "file", path: "src/auth/auth.controller.ts" },
              { name: "auth.module.ts", type: "file", path: "src/auth/auth.module.ts" },
            ],
          },
          {
            name: "config",
            type: "folder",
            children: [
              { name: "app.config.ts", type: "file", path: "src/config/app.config.ts" },
              { name: "database.config.ts", type: "file", path: "src/config/database.config.ts" },
            ],
          },
          {
            name: "shared",
            type: "folder",
            children: [
              {
                name: "decorators",
                type: "folder",
                children: [
                  { name: "roles.decorator.ts", type: "file", path: "src/shared/decorators/roles.decorator.ts" },
                  { name: "index.ts", type: "file", path: "src/shared/decorators/index.ts" },
                ],
              },
              {
                name: "dto",
                type: "folder",
                children: [
                  { name: "global-response.dto.ts", type: "file", path: "src/shared/dto/global-response.dto.ts" },
                  { name: "pagination-query.dto.ts", type: "file", path: "src/shared/dto/pagination-query.dto.ts" },
                  { name: "pagination-response.dto.ts", type: "file", path: "src/shared/dto/pagination-response.dto.ts" },
                  { name: "index.ts", type: "file", path: "src/shared/dto/index.ts" },
                ],
              },
              {
                name: "enums",
                type: "folder",
                children: [
                  { name: "user-role.enum.ts", type: "file", path: "src/shared/enums/user-role.enum.ts" },
                  { name: "environment.enum.ts", type: "file", path: "src/shared/enums/environment.enum.ts" },
                  { name: "auth-provider.enum.ts", type: "file", path: "src/shared/enums/auth-provider.enum.ts" },
                  { name: "config-keys.enum.ts", type: "file", path: "src/shared/enums/config-keys.enum.ts" },
                  { name: "index.ts", type: "file", path: "src/shared/enums/index.ts" },
                ],
              },
              {
                name: "filters",
                type: "folder",
                children: [
                  { name: "http-exception.filter.ts", type: "file", path: "src/shared/filters/http-exception.filter.ts" },
                  { name: "index.ts", type: "file", path: "src/shared/filters/index.ts" },
                ],
              },
              {
                name: "guards",
                type: "folder",
                children: [
                  { name: "roles.guard.ts", type: "file", path: "src/shared/guards/roles.guard.ts" },
                  { name: "index.ts", type: "file", path: "src/shared/guards/index.ts" },
                ],
              },
              {
                name: "interceptors",
                type: "folder",
                children: [
                  { name: "response-transform.interceptor.ts", type: "file", path: "src/shared/interceptors/response-transform.interceptor.ts" },
                  { name: "index.ts", type: "file", path: "src/shared/interceptors/index.ts" },
                ],
              },
              {
                name: "services",
                type: "folder",
                children: [
                  { name: "typed-config.service.ts", type: "file", path: "src/shared/services/typed-config.service.ts" },
                  { name: "index.ts", type: "file", path: "src/shared/services/index.ts" },
                ],
              },
              {
                name: "types",
                type: "folder",
                children: [
                  { name: "config.types.ts", type: "file", path: "src/shared/types/config.types.ts" },
                  { name: "index.ts", type: "file", path: "src/shared/types/index.ts" },
                ],
              },
              {
                name: "utils",
                type: "folder",
                children: [
                  { name: "password.util.ts", type: "file", path: "src/shared/utils/password.util.ts" },
                  { name: "environment.util.ts", type: "file", path: "src/shared/utils/environment.util.ts" },
                  { name: "index.ts", type: "file", path: "src/shared/utils/index.ts" },
                ],
              },
              { name: "shared.module.ts", type: "file", path: "src/shared/shared.module.ts" },
              { name: "index.ts", type: "file", path: "src/shared/index.ts" },
            ],
          },
          {
            name: "user",
            type: "folder",
            children: [
              {
                name: "dto",
                type: "folder",
                children: [
                  { name: "user-response.dto.ts", type: "file", path: "src/user/dto/user-response.dto.ts" },
                  { name: "update-user.dto.ts", type: "file", path: "src/user/dto/update-user.dto.ts" },
                  { name: "change-password.dto.ts", type: "file", path: "src/user/dto/change-password.dto.ts" },
                  { name: "index.ts", type: "file", path: "src/user/dto/index.ts" },
                ],
              },
              {
                name: "schemas",
                type: "folder",
                children: [
                  { name: "user.schema.ts", type: "file", path: "src/user/schemas/user.schema.ts" },
                  { name: "user-provider.schema.ts", type: "file", path: "src/user/schemas/user-provider.schema.ts" },
                  { name: "index.ts", type: "file", path: "src/user/schemas/index.ts" },
                ],
              },
              { name: "user.controller.ts", type: "file", path: "src/user/user.controller.ts" },
              { name: "user.service.ts", type: "file", path: "src/user/user.service.ts" },
              { name: "user.module.ts", type: "file", path: "src/user/user.module.ts" },
            ],
          },
          { name: "app.module.ts", type: "file", path: "src/app.module.ts" },
          { name: "app.controller.ts", type: "file", path: "src/app.controller.ts" },
          { name: "app.service.ts", type: "file", path: "src/app.service.ts" },
          { name: "main.ts", type: "file", path: "src/main.ts" },
        ],
      },
      {
        name: "scripts",
        type: "folder",
        children: [
          { name: "setup.sh", type: "file", path: "scripts/setup.sh" },
          { name: "setup.bat", type: "file", path: "scripts/setup.bat" },
        ],
      },
      { name: "env.sample", type: "file", path: "env.sample" },
      { name: "package.json", type: "file", path: "package.json" },
      { name: "tsconfig.json", type: "file", path: "tsconfig.json" },
      { name: "tsconfig.build.json", type: "file", path: "tsconfig.build.json" },
      { name: "nest-cli.json", type: "file", path: "nest-cli.json" },
      { name: "README.md", type: "file", path: "README.md" },
    ],
  },
]

